import { GET_POPULAR_HOUSING_API_ENDPOINT } from '@/constants';
import { IHousingObjectResponse } from '@/types';
import { getAcceptLanguageHeader, type Locale } from '@/config/i18n/locales';
import { fetchWithAuth } from '@/lib/fetchWithAuth';
import { withServerTiming } from '@/lib/serverTiming';
import { logSsrFetch } from '@/lib/ssrLog';

export const fetchPopularHousingSsr = async (locale?: Locale): Promise<IHousingObjectResponse[]> =>
  withServerTiming('fetchPopularHousingSsr', async () => {
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      if (locale) headers['Accept-Language'] = getAcceptLanguageHeader(locale);

      const url = `${process.env.NEXT_PUBLIC_API_URL}${GET_POPULAR_HOUSING_API_ENDPOINT}?project=false`;
      const { res, auth, ms } = await fetchWithAuth(url, {
        method: 'GET',
        cache: 'no-store',
        headers,
      });
      logSsrFetch({ url, timing: ms, status: res.status, auth });

      if (!res.ok) return [];
      return (await res.json()) as IHousingObjectResponse[];
    } catch (err) {
      console.error('fetchPopularHousingSsr ERROR:', err);
      return [];
    }
  });
